import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { House01Icon } from '@hugeicons/core-free-icons';

function MultiFamily(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size;
    return (
        <HugeiconsIcon icon={House01Icon} className={className} color={fill} size={size} />
    )
}

export default MultiFamily;